import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteRegionChannelSetting } from '~/services/PromoService';

import { regionChannelSettingQueryKeys } from './regionChannelSettingQueryKeys';

export function useDeleteRegionChannelSetting() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteRegionChannelSetting(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: regionChannelSettingQueryKeys.lists() });
    },
  });
}
